<div class="col-md-12 imagePreview-tab">
  <p class="closeButton" (click)="closeImgPreview()">X</p>
  <img src="../../../../assets/img/home/leftarrow_ic.svg" alt="" class="slickPrev">
  <img src="../../../../assets/img/home/rightarrow_ic.svg" alt="" class="slickNext">
  <div class="preview-slider">
    <div class="slider-image">
      <ngx-slick-carousel class="row " #slickModal="slick-carousel" [config]="slideConfig">
        <div ngxSlickItem *ngFor="let profile of previewImgArray" class="imgContainer">
          <img src="{{profile.fullPhotoPath}}" alt="" class="profileImg">
        </div>

      </ngx-slick-carousel>
    </div>

  </div>
